import React from 'react'
import cx from 'classnames'
// TODO: Try to remove `react-motion` and do this with CSS animation
import { Motion, spring } from 'react-motion'
import config from '../../config'
import toReactComponent from 'svgr.macro'
const OpenButtonIcon = toReactComponent('./widget_button_open.svg')
const CloseButtonIcon = toReactComponent('./widget_button_close.svg')

const styles = `
  .widgetButtonInnerIcon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    transform-origin: top left;
    margin-top: -1px;
  }

  .widgetButtonInnerIconOpen {
    width: 32px';
    height: 32px;
  },
  
  .widgetButtonInnerIconClose {
    width: 36px;
    height: 36px;
  }
`

const ButtonIcon = ({ isActive, type }) => {
  const isIconTypeOpen = type === 'open'

  const defaultStyle = isIconTypeOpen
    ? {
        opacity: 1,
        rotate: 0,
        scale: 1,
      }
    : {
        opacity: 0,
        rotate: -45,
        scale: 0,
      }

  const motionStyle = isIconTypeOpen
    ? {
        opacity: spring(isActive ? 0 : 1, config.presets.default),
        rotate: spring(isActive ? 45 : 0, config.presets.default),
        scale: spring(isActive ? 0 : 1, config.presets.default),
      }
    : {
        opacity: spring(isActive ? 1 : 0, config.presets.default),
        rotate: spring(isActive ? 0 : -45, config.presets.default),
        scale: spring(isActive ? 1 : 0, config.presets.default),
      }

  const iconStyle = interpolatingStyles => ({
    opacity: interpolatingStyles.opacity,
    transform: `
      rotate(${interpolatingStyles.rotate}deg)
      scale(${interpolatingStyles.scale})
      translate(-50%, -50%)
    `,
  })

  const className = cx({
    ['widgetButtonInnerIcon']: true,
    ['widgetButtonInnerIconOpen']: isIconTypeOpen,
    ['widgetButtonInnerIconClose']: !isIconTypeOpen,
  })

  return (
    <>
      <style>{styles}</style>
      <Motion defaultStyle={defaultStyle} style={motionStyle}>
        {interpolatingStyles =>
          isIconTypeOpen ? (
            <OpenButtonIcon
              alt='Launcher Icon'
              className={className}
              style={iconStyle(interpolatingStyles)}
            />
          ) : (
            <CloseButtonIcon
              alt='Close Icon'
              className={className}
              style={iconStyle(interpolatingStyles)}
            />
          )
        }
      </Motion>
    </>
  )
}

export default ButtonIcon
